import { Injectable } from '@angular/core';
import { MenuAbertoHeartbeat, TipoAplicacaoSessao } from '../../../core/interfaces/sessao';

/**
 * Lista das aplicações abertas agora no navegador: os microfrontends com iframe
 * vivo e a tela interna ativa no painel. Alimenta o `menus` do ping de sessão,
 * que é como o painel de sessões do admin sabe onde cada usuário está.
 */
@Injectable({
  providedIn: 'root',
})
export class OpenAppsRegistryService {
  private readonly abertos = new Map<string, MenuAbertoHeartbeat>();

  /** Registra a aplicação. Chamar de novo para a mesma aplicação não duplica. */
  abrir(menuId: number, tipo: TipoAplicacaoSessao): void {
    this.abertos.set(this.chave(menuId, tipo), { id: menuId, tipo, novaAba: false });
  }

  fechar(menuId: number, tipo: TipoAplicacaoSessao): void {
    this.abertos.delete(this.chave(menuId, tipo));
  }

  listar(): MenuAbertoHeartbeat[] {
    return Array.from(this.abertos.values());
  }

  private chave(menuId: number, tipo: TipoAplicacaoSessao): string {
    return `${tipo}:${menuId}`;
  }
}
